import { StepInfo } from './step-info';
export class AddUserSteps {
  private steps: StepInfo[] = [];
  public activeIndex: number = 0;

  public get length(): number {
    return this.steps.length;
  }

  public getActiveStep(): StepInfo {
    return this.steps[this.activeIndex];
  }

  public getStepByIndex(index?: number): StepInfo {
    if (index && index >= 0 && index < this.steps.length) {
      return this.steps[index];
    }
    return null;
  }

  public getStepByID(ID: string): StepInfo {
    return this.steps.find((s) => s.ID === ID);
  }

  public push(step: StepInfo) {
    if (this.steps.some((s) => s.ID === step.ID)) {
      return;
    }
    this.steps.push(step);
  }

  public removeStep(stepId: string) {
    this.steps = this.steps.filter((s) => s.ID !== stepId);
  }

  public getLength(): number {
    return this.steps.length;
  }

  public isLastStep(index?: number): boolean {
    const stepIndex = index ?? this.activeIndex;
    return stepIndex === this.steps.length - 1;
  }

  public isFirstStep(index?: number): boolean {
    const stepIndex = index ?? this.activeIndex;
    return stepIndex === 0;
  }

  public stepIsNotActiveStep(nextIndex?: number, ID?: string): boolean {
    if (this.activeIndex === nextIndex) {
      return false;
    }
    if (this.getActiveStep().ID === ID) {
      return false;
    }
    return true;
  }
  public getNextEnabledStep(): StepInfo | null {
    if (this.isLastStep()) {
      return null;
    }
    let nextIndex = this.activeIndex + 1;
    while (this.steps[nextIndex].isDisabled() && !this.isLastStep(nextIndex)) {
      nextIndex++;
    }
    return this.steps[nextIndex];
  }

  public iterateStep(options?: { reverse?: boolean }): void {
    const nextValidIndex: number = this.nextValidIndex(options?.reverse);
    this.activeIndex = nextValidIndex;
  }

  public nextValidIndex(reverse?: boolean): number {
    const iterator: number = reverse ? -1 : 1;
    let newIndex = this.activeIndex + iterator;
    while (this.steps[newIndex].isDisabled() && newIndex < this.steps.length && newIndex >= 0) {
      newIndex += iterator;
    }
    return newIndex;
  }

  constructor(init?: Partial<AddUserSteps>) {
    Object.assign(this, init);
  }
}
